import { useEffect, useRef, useState } from 'react';

import { useSelectors } from '../../hooks/use-selectors';
import { useStyles } from './toast-container.styles';
import Toast from './toast/toast';

const ToastContainer = () => {
  const [width, setWidth] = useState(550);
  const containerRef = useRef<HTMLDivElement>();
  const { toasts } = useSelectors.Toast();
  const classes = useStyles({ width });

  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current?.clientWidth);
    }
  }, [toasts.length]);

  return (
    <div
      className={classes.root}
      data-testid='toast-container'
      ref={containerRef}
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  );
};

export default ToastContainer;
